var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as QueryService from "../service/query-service.js";
import { Resource } from "./Resource.js";
/**
 * Defines a saved Query in a [[Book]].
 *
 * Queries can be saved on Books by users.
 *
 * @public
 */
export class Query extends Resource {
    constructor(book, payload) {
        super(payload);
        this.book = book;
    }
    /** @internal */
    getConfig() {
        return this.book.getConfig();
    }
    /**
     * Gets the Query universal identifier.
     *
     * @returns The Query universal identifier
     */
    getId() {
        return this.payload.id;
    }
    /**
     * Gets the title of this saved Query.
     *
     * @returns The title of this saved Query
     */
    getTitle() {
        return this.payload.title;
    }
    /**
     * Sets the title of this saved Query.
     *
     * @param title - The title of this saved Query
     *
     * @returns This Query, for chaining
     */
    setTitle(title) {
        this.payload.title = title;
        return this;
    }
    /**
     * Gets the query string to be executed.
     *
     * @returns This Query string to be executed
     */
    getQuery() {
        return this.payload.query;
    }
    /**
     * Sets the query string associated with this saved Query.
     *
     * @param query - The query string to be executed
     *
     * @returns This Query, for chaining
     */
    setQuery(query) {
        this.payload.query = query;
        return this;
    }
    /**
     * Perform create new Query.
     *
     * @returns This Query, for chaining
     */
    create() {
        return __awaiter(this, void 0, void 0, function* () {
            this.payload = yield QueryService.createSavedQuery(this.book.getId(), this.payload, this.getConfig());
            this.updateQueryCache();
            return this;
        });
    }
    /**
     * Perform update Query, applying pending changes.
     *
     * @returns This Query, for chaining
     */
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            this.payload = yield QueryService.updateSavedQuery(this.book.getId(), this.payload, this.getConfig());
            this.updateQueryCache();
            return this;
        });
    }
    /**
     * Perform delete Query.
     *
     * @returns This Query, for chaining
     */
    remove() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryId = this.getId();
            if (!queryId) {
                throw new Error("Query id null!");
            }
            this.payload = yield QueryService.deleteSavedQuery(this.book.getId(), queryId, this.getConfig());
            this.updateQueryCache(true);
            return this;
        });
    }
    /** @internal */
    updateQueryCache(deleted) {
        if (this.book.queries) {
            this.book.queries = this.book.queries.filter((q) => q.getId() !== this.getId());
            if (!deleted) {
                this.book.queries.push(this);
            }
        }
    }
}
//# sourceMappingURL=Query.js.map